// EntityNoticeEntry (variantA) captures a WhatsApp phone before the visitor
// moves through the multi-step, page-reloading signup flow. Persist it in
// localStorage only — same reasoning as landing-pages/identity's
// hero-phone-storage: never a URL param (leaks into logs/referrers), never a
// cookie (sent to the server on every request). Read once by
// useEntityNoticeFinalizeSignup, cleared on signup success.
const ENTITY_NOTICE_PHONE_KEY = 'auth-core:entity-notice-phone'

export function saveEntityNoticePhone(digits: string): void {
  if (typeof window === 'undefined') return
  try {
    if (digits) {
      localStorage.setItem(ENTITY_NOTICE_PHONE_KEY, digits)
    } else {
      localStorage.removeItem(ENTITY_NOTICE_PHONE_KEY)
    }
  } catch {
    // Storage can be unavailable (private mode, quota). Losing the value only
    // means the phone never reaches the signup request.
  }
}

export function readEntityNoticePhone(): string {
  if (typeof window === 'undefined') return ''
  try {
    return localStorage.getItem(ENTITY_NOTICE_PHONE_KEY) ?? ''
  } catch {
    return ''
  }
}

export function clearEntityNoticePhone(): void {
  if (typeof window === 'undefined') return
  try {
    localStorage.removeItem(ENTITY_NOTICE_PHONE_KEY)
  } catch {
    // ignore — see saveEntityNoticePhone
  }
}
